export const DEFAULT_PER_PAGE_OPTIONS: number[] = [25, 50, 100, 200];
